import {
  FETCH_QUIZRESULTS,
  FETCH_QUIZRESULT,
  FETCH_QUIZRESULT_SUMMARY,
  LOADING_QUIZRESULTS
} from "../actions/type";

const INIT_STATE = {
  quizResults: [],
  quizResultMap: {},
  pagination: null,
  summary: null,
  isLoadingQuizResults: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_QUIZRESULTS:
      return {
        ...state,
        quizResults: payload.quizResults,
        quizResultMap: payload.quizResults.reduce((map, item) => {
          map[item._id] = item;
          return map;
        }, {}),
        pagination: payload.pagination
      };

    case FETCH_QUIZRESULT:
      return {
        ...state,
        quizResultMap: {
          ...state.quizResultMap,
          [payload.quizResult._id]: payload.quizResult
        }
      };

    case FETCH_QUIZRESULT_SUMMARY:
      return {
        ...state,
        summary: payload.summary
      };

    case LOADING_QUIZRESULTS:
      return {
        ...state,
        isLoadingQuizResults: payload
      };

    default:
      return state;
  }
};
